import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AlertService } from 'app/services/alert.service';
import { LoggerService } from 'app/services/logger.service';
import { catchError, map, of, switchMap, tap } from 'rxjs';

import { TransfersService } from '../services/transfers.service';
import * as TransferActions from './transfers.actions';

@Injectable()
export class TransfersEffects {
    private _actions$ = inject(Actions);
    private _store = inject(Store);
    private logger = inject(LoggerService);
    private _transferService = inject(TransfersService);
    private _alertService = inject(AlertService);

    messages = {
        getAllError: 'Error getting all transfers',
        connectionError: 'Error connecting to the server',
        unknownError: 'Unknown error',
    };

    // ------------------------------------------------------------------------------------------
    // @ Effects
    // ------------------------------------------------------------------------------------------

    // Get All Transfers
    getAllTransfers$ = createEffect(() =>
        this._actions$.pipe(
            ofType(TransferActions.loadTransfers),
            switchMap(() => {
                return this._transferService.getAll().pipe(
                    map((res) => {
                        return TransferActions.loadTransfersSuccess({
                            transfers: res.data,
                        });
                    }),
                    catchError((error) =>
                        of(
                            TransferActions.loadTransfersFailure({
                                error:
                                    error?.error?.message ||
                                    this.messages.unknownError,
                            })
                        )
                    )
                );
            })
        )
    );

    // Get One Transfer
    // getTransfer$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(TransferActions.loadTransfer),
    //         switchMap((action) => {
    //             return this._transferService.getOne(action.id).pipe(
    //                 map((res) => {
    //                     return TransferActions.loadTransferSuccess({
    //                         transfer: res.data,
    //                     });
    //                 }),
    //                 catchError((error) =>
    //                     of(
    //                         TransferActions.loadTransferFailure({
    //                             error:
    //                                 error?.error?.message ||
    //                                 this.messages.unknownError,
    //                         })
    //                     )
    //                 )
    //             );
    //         })
    //     )
    // );

    // Create Transfer
    createTransfer$ = createEffect(() =>
        this._actions$.pipe(
            ofType(TransferActions.createTransfer),
            switchMap((action) => {
                return this._transferService.create(action.data).pipe(
                    map((res) => {
                        return TransferActions.createTransferSuccess({
                            transfer: res.data,
                            success: 'Transfer successfully processed!',
                        });
                    }),
                    catchError((error) =>
                        of(
                            TransferActions.createTransferFailure({
                                error:
                                    error?.error?.message ||
                                    this.messages.unknownError,
                            })
                        )
                    )
                );
            })
        )
    );

    // Update Transfer
    // updateTransfer$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(TransferActions.updateTransfer),
    //         switchMap((action) => {
    //             return this._transferService
    //                 .update(action.TransferData, action.id)
    //                 .pipe(
    //                     map((res) => {
    //                         return TransferActions.updateTransferSuccess({
    //                             transfer: res.data,
    //                             success: 'Transfer updated successfully',
    //                         });
    //                     }),
    //                     catchError((error) =>
    //                         of(
    //                             TransferActions.updateTransferFailure({
    //                                 error:
    //                                     error?.error?.message ||
    //                                     this.messages.unknownError,
    //                             })
    //                         )
    //                     )
    //                 );
    //         })
    //     )
    // );

    // Delete Transfer
    // deleteTransfer$ = createEffect(() =>
    //     this._actions$.pipe(
    //         ofType(TransferActions.deleteTransfer),
    //         switchMap((action) => {
    //             return this._transferService.delete(action.id).pipe(
    //                 map(() => {
    //                     return TransferActions.deleteTransferSuccess({
    //                         id: action.id,
    //                         success: 'Transfer deleted successfully',
    //                     });
    //                 }),
    //                 catchError((error) =>
    //                     of(
    //                         TransferActions.deleteTransferFailure({
    //                             error:
    //                                 error?.error?.message ||
    //                                 this.messages.unknownError,
    //                         })
    //                     )
    //                 )
    //             );
    //         })
    //     )
    // );

    // ------------------------------------------------------------------------------------------
    // @ Alerts
    // ------------------------------------------------------------------------------------------

    onTransferActionSuccess$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(
                    TransferActions.createTransferSuccess
                    // TransferActions.updateTransferSuccess,
                    // TransferActions.deleteTransferSuccess
                ),
                tap((action) => {
                    this._alertService.showAlert(action.success, 'success');
                })
            ),
        { dispatch: false }
    );

    onTransferActionFailure$ = createEffect(
        () =>
            this._actions$.pipe(
                ofType(
                    TransferActions.loadTransfersFailure,
                    TransferActions.loadTransferFailure,
                    TransferActions.createTransferFailure
                    // TransferActions.updateTransferFailure,
                    // TransferActions.deleteTransferFailure
                ),
                tap((action) => {
                    this._alertService.showAlert(action.error, 'error');
                })
            ),
        { dispatch: false }
    );
}
